import { Button, IconButton, Stack, TextField, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { usePlanningStore } from '@tom-ui/planning'
import { CloseIcon, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { AggregateIssuesViewStore } from '../../Stores/AggregateIssuesViewStore'

type Props = {
  store: AggregateIssuesViewStore
}

export const IssuesFilterDrawer: FC<Props> = observer(({ store }) => {
  const { drawerStore } = usePlanningStore()
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Stack spacing={theme.customSpacing.m}>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        sx={{ width: '360px', borderBottom: 1, borderColor: 'divider' }}
        p={theme.customSpacing.s}
      >
        <Stack direction='row' alignItems='center' spacing={theme.customSpacing.s}>
          <IconButton onClick={() => drawerStore.close()} sx={{ mb: 1 }}>
            <CloseIcon />
          </IconButton>
          <Typography variant='subtitle1'>{t('filters', 'Filters')}</Typography>
        </Stack>
        <Stack direction='row' alignItems='center' spacing={theme.customSpacing.s}>
          <Button variant='text' color='inherit' onClick={() => store.clearFilters()}>
            {t('clearAll', 'Clear all')}
          </Button>
          <Button
            variant='contained'
            onClick={() => {
              store.setEnableFilters(true)
              drawerStore.close()
            }}
          >
            {t('apply', 'Apply')}
          </Button>
        </Stack>
      </Stack>
      <Stack spacing={theme.customSpacing.m} p={theme.customSpacing.s}>
        <Typography variant='subtitle1'>{t('transportDetails', 'Transport Details')}</Typography>
        <TextField
          label={t('carrierName', 'Carrier name')}
          sx={{ width: '100%' }}
          defaultValue={store.carrierNameFilter ?? ''}
          value={store.carrierNameFilter ?? ''}
          onChange={event => {
            store.setCarrierNameFilter(event.currentTarget.value)
          }}
        />
      </Stack>
      {/* <Stack spacing={2}>
        <Typography variant='subtitle1'>{t('issueDetails', 'Issue Details')}</Typography>
      </Stack> */}
    </Stack>
  )
})
